jQuery(function ($) {
    $(document).ready(function() {
        //open mobile menu 
        const menuIcon = $('[data-nav-menu-toggle]');
        

        // WCAG Event listeners
        menuIcon.on('keydown', function(e) {
            switch (e.key) {
                case "Enter":
                case " ":
                    toggleMenu($(this), e);
                    break;
            }
        });

        menuIcon.on('click', function(e) {
            toggleMenu($(this), e);
        });

        function toggleMenu(element, event) {
            event.preventDefault();
            
            const menu = $('[data-nav-menu-mobile]');
            menu.toggleClass('open');
            $('body').toggleClass('menu-open');

            if (menu.hasClass('open')) {
                $(element).attr('aria-expanded', 'true');
                $(element).attr('aria-label', 'Sluit menu');
                menu.attr('aria-hidden', 'false');
                $('body, html').css('overflow', 'hidden'); //dont allow scrolling the body if menu is open
            } else {
                $(element).attr('aria-expanded', 'false');
                $(element).attr('aria-label', 'Open menu');
                menu.attr('aria-hidden', 'true');
                $('body, html').attr('style', ''); //allow scrolling the body again
            }
        }
    });
});